import * as Yup from "yup";

export const AddOrUpdateMaterialReservationItemSchema = Yup.object().shape({
  material: Yup.number().nullable().required("Material is required"),
  reservation_date: Yup.string()
    .nullable()
    .required("Reservation date is required"),
  quantity: Yup.number().nullable().required("Quantity is required"),
});
